import React from "react";
import { Instagram, Linkedin, MapPin, Phone, ArrowUpRight } from "lucide-react";
import { BRAND, buildWhatsappLink } from "@/lib/brand";
import { WhatsappIcon } from "@/components/Navbar";

const NAV = [
  { label: "Início", href: "#inicio" },
  { label: "Sobre", href: "#sobre" },
  { label: "Para sua empresa", href: "#solucoes" },
  { label: "Agendamento", href: "#agendamento" },
  { label: "Cadastro", href: "#cadastro" },
];

export default function Footer() {
  return (
    <footer id="contatos" className="scroll-mt-nav bg-efory-ink text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center">
              <img src={BRAND.logo} alt="EFORY" className="h-9 w-auto object-contain" />
            </div>
            <p className="mt-5 text-white/55 max-w-sm leading-relaxed">
              Soluções financeiras e comerciais que conectam marketing, vendas, CRM, conteúdo e
              gestão para acelerar o crescimento do seu negócio.
            </p>
            <div className="mt-6 flex gap-3">
              <a
                href={BRAND.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="h-11 w-11 flex items-center justify-center rounded-full border border-white/15 text-white/80 hover:text-white hover:border-efory-blue hover:bg-efory-blue/15 transition-all"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href={BRAND.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="h-11 w-11 flex items-center justify-center rounded-full border border-white/15 text-white/80 hover:text-white hover:border-[#0A66C2] hover:bg-[#0A66C2]/15 transition-all"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a
                href={buildWhatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="h-11 w-11 flex items-center justify-center rounded-full border border-white/15 text-white/80 hover:text-white hover:border-[#25D366] hover:bg-[#25D366]/15 transition-all"
                aria-label="WhatsApp"
              >
                <WhatsappIcon className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Nav */}
          <div className="md:col-span-3">
            <h4 className="font-heading font-bold text-sm uppercase tracking-[0.2em] text-white/50">
              Navegação
            </h4>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a
                    href={n.href}
                    data-testid={`footer-link-${n.href.replace("#", "")}`}
                    className="text-white/70 hover:text-efory-blue transition-colors inline-flex items-center gap-1"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacts */}
          <div className="md:col-span-4">
            <h4 className="font-heading font-bold text-sm uppercase tracking-[0.2em] text-white/50">
              Contatos
            </h4>
            <ul className="mt-5 space-y-4">
              <li>
                <a
                  href={buildWhatsappLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors group"
                >
                  <span className="h-10 w-10 rounded-lg bg-white/5 flex items-center justify-center text-efory-blue">
                    <Phone className="h-5 w-5" />
                  </span>
                  <span>
                    <span className="block text-xs text-white/45">WhatsApp</span>
                    {BRAND.whatsappDisplay}
                  </span>
                  <ArrowUpRight className="h-4 w-4 ml-auto opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              </li>
              <li>
                <a
                  href={BRAND.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors group"
                >
                  <span className="h-10 w-10 rounded-lg bg-white/5 flex items-center justify-center text-efory-blue">
                    <Instagram className="h-5 w-5" />
                  </span>
                  <span>
                    <span className="block text-xs text-white/45">Instagram</span>
                    {BRAND.instagramHandle}
                  </span>
                  <ArrowUpRight className="h-4 w-4 ml-auto opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/70">
                <span className="h-10 w-10 rounded-lg bg-white/5 flex items-center justify-center text-efory-blue">
                  <MapPin className="h-5 w-5" />
                </span>
                <span>
                  <span className="block text-xs text-white/45">Atendimento</span>
                  Online e presencial · Brasil
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-white/45">
          <p>© {new Date().getFullYear()} EFORY. Todos os direitos reservados.</p>
          <a href="/login" data-testid="footer-admin-link" className="hover:text-white/80 transition-colors">
            Área restrita
          </a>
        </div>
      </div>
    </footer>
  );
}
